import { Icon } from "./Icon.tsx";

/** "Hidden from the map" state (ElementBrowser.tsx's per-category toggle). */
export function EyeOffIcon() {
  return (
    <Icon>
      <path d="M9.5 9.5a3 3 0 0 0 4.2 4.2" />
      <path d="M6.5 6.5C4 8.2 2 12 2 12s4 7 10 7a10.4 10.4 0 0 0 4.2-.9M10.6 5.1A10.8 10.8 0 0 1 12 5c6 0 10 7 10 7a17.9 17.9 0 0 1-3.2 4.1" />
      <path d="M3 3l18 18" />
    </Icon>
  );
}
